


import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { useEffect, useState } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import Button from "../../shared/button/Btn"
import styled from "styled-components"
import PageTopTitle from "../../shared/PageTopTitle"

import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputText from "../../shared/input/new/InputText"
import InputNumberNew from "../../shared/input/new/InputNumberNew"
import InputDate from "../../shared/input/new/InputDate"
import InputNewAracTypeSelect from "../../shared/input/new/InputNewAracTypeSelect"
import InputCaseTypeSelect from "../../shared/input/new/InputCaseTypeSelect"
import { AdminAracEkleOptions } from "../../../utils/adminAracEkleOptions"
import moment from "moment"
import { profilOzVarlikAracEkle } from "../../../features/companyProfile/companyProfileSlice"
import useWindowDimensions from "../../../hooks/useWindowSize"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0;
            width: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;

            .row{
                width: 100%;
                p{
                    font-size: 12px;
                    color: var(--color-main);
                    margin-top: 5px;
                }
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 50px;
        }
    }


    @media (max-width: 700px){
        .modal{
            width: 100vw;
            height: 100vh;
            border-radius: 0;
        }

    }

    @media (max-width: 700px){

        .content{
            width: calc(100% - 40px) !important;
        }

        .button-grp{
            padding: 0;
        }
    }
`

const AddProfilimAraclarimModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const {topBarCompanyInfo} = useSelector((state)=> state.companyProfile)

    const {windowDimensions} = useWindowDimensions()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [data, setData] = useState({
        plaka: "",
        muayeneGecerlilik: "",
        trafikGecerlilik: "",
        kaskoGecerlilik: "",
        renk: "",
        modelYili: "",
        model: "",
        marka:""
    })

    const [aracType, setAracType] = useState(null)
    const [kasaType ,setKasaType] = useState(null)
    const [initialCaseType, setInitialCaseType] = useState(null)
    const [isSubmitted, setIsSubmitted] = useState(false)
    const currentYear = new Date().getFullYear(); 
    
    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleChange = (e) => {
        const { name, value } = e.target;
    
        if (name === "plaka") {
            const newValue = value.replace(/\s/g, '');
            setData((prev) => ({ ...prev, [name]: newValue }));
        } else {
            setData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = () => {
        setIsSubmitted(true)

        if(data?.plaka && aracType && kasaType){
            const addData = {
                //! zorunlu alanlar
                phoneNumber: topBarCompanyInfo?.yetkiliPhoneNumber,
                truckType: aracType?.name,
                truckPlateNumber: data?.plaka,
                
                //! opsiyonel alanlar
                //! kasa ve zemin
                trailerTypeId: kasaType?.id,

                //! araç detay
                truckBrand: data?.marka,
                truckModel: data?.model,
                truckModelYear: parseInt(data?.modelYili) || 0,
                colorVehicle: data?.renk,

                //! tarihler
                trafikSigortasıGecerlilikTarihi: moment(data?.trafikGecerlilik, "YYYY/MM/DD").format("DD.MM.YYYY") !== "Invalid date" ? moment(data?.trafikGecerlilik, "YYYY/MM/DD").format("DD.MM.YYYY") : "",
                muayeneGecerlilikTarihi: moment(data?.muayeneGecerlilik, "YYYY/MM/DD").format("DD.MM.YYYY") !== "Invalid date" ? moment(data?.muayeneGecerlilik, "YYYY/MM/DD").format("DD.MM.YYYY") : "",
                kaskoGecerlilikTarihi: moment(data?.kaskoGecerlilik, "YYYY/MM/DD").format("DD.MM.YYYY") !== "Invalid date" ? moment(data?.kaskoGecerlilik, "YYYY/MM/DD").format("DD.MM.YYYY") : ""
            }
            dispatch(profilOzVarlikAracEkle(addData))
        }
    }
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"Araç Ekle"}/>
        <div className="content">
            <div className="row">
                <InputText data={data?.plaka} setData={handleChange} labelText={"Plaka*"} name={"plaka"} inputWidth={"100%"} />
                {
                    isSubmitted && !data?.plaka &&
                    <p>Zorunlu Alan</p>
                }
            </div>

            <div className="row">
                <InputNewAracTypeSelect initialOptions={AdminAracEkleOptions} setInitialCaseType={setInitialCaseType} data={aracType} setData={setAracType} inputWidth={"100%"} labelText="Araç Türü*" name={"aracType"} />
                {
                    isSubmitted && !aracType &&
                    <p>Zorunlu Alan</p>
                }
            </div>
            
            {
                aracType?.name !== "Çekici" &&
                <div className="row">
                    <InputCaseTypeSelect  initialOptions={initialCaseType} data={kasaType} setData={setKasaType} inputWidth={"100%"} labelText="Kasa Tipi*" name={"selectCaseType"} />
                    {
                        isSubmitted && !kasaType &&
                        <p>Zorunlu Alan</p>
                    }
                </div>
            }

            <InputText data={data?.marka} setData={handleChange} labelText={"Marka"} name={"marka"} inputWidth={"100%"} />
            <InputText data={data?.model} setData={handleChange} labelText={"Model"} name={"model"} inputWidth={"100%"} />
            <div className="row">
                <InputNumberNew max={4} data={data?.modelYili} setData={handleChange} labelText={"Model Yılı"} name={"modelYili"} inputWidth={"100%"} />
                {data?.modelYili && (data?.modelYili > currentYear)  &&
                    <p>Geçerli bir tarih giriniz.</p>
                }
                
            </div>
            
            <InputText data={data?.renk} setData={handleChange} labelText={"Rengi"} name={"renk"} inputWidth={"100%"} />

            <InputDate data={data?.muayeneGecerlilik} setData={handleChange} labelText={"Muayene Geçerlilik Tarihi"} name={"muayeneGecerlilik"} inputWidth={"100%"} />
            <InputDate data={data?.trafikGecerlilik} setData={handleChange} labelText={"Trafik Sigortası Geçerlilik Tarihi"} name={"trafikGecerlilik"} inputWidth={"100%"} />
            <InputDate data={data?.kaskoGecerlilik} setData={handleChange} labelText={"Kasko Sigortası Geçerlilik Tarihi"} name={"kaskoGecerlilik"} inputWidth={"100%"} />
        </div>

        <div className="button-grp">
            <Button bgColor={"#E85446"} color={"#fff"} width="280px" handleClick={handleSubmit}>Ekle</Button>
            <Button bgColor={"transparent"} color={"#E85446"} width="280px" handleClick={() => dispatch(showNestedModal("profilAracClose"))}>Kapat</Button>
        </div>
    </div>
</ModalContainer>
  )
}

export default AddProfilimAraclarimModal